<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @search-reset="searchClear"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="primary"
            size="small"
            v-if="scope.row.status=='WAIT_PAY'"
            plain
            @click.stop="handlePay(scope.row,scope.index)"
          >支付</el-button>
        </template>
      </avue-crud>
      <el-dialog
        :visible.sync="payMoneyDialog"
        title="选择支付方式"
        center
        width="550px"
      >
        <div style="font-size: 14px">
          <div style="display: flex;justify-content:center;margin-top:40px">
            <el-radio
              v-model="radio"
              label="BALANCE"
              v-if="isEnough==='false'"
            >
              账户余额(
              <span style="color:red;font-size:12px;">余额不足</span>
              <a
                href="#"
                style="color:#409EFF;text-decoration: underline;margin-left:8px"
                @click="toPayBalance"
              >去充值</a> )
            </el-radio>
            <el-radio
              v-model="radio"
              label="BALANCE"
              v-if="isEnough==='true'"
            >账户余额({{balance}}元)</el-radio>
            <el-radio
              v-model="radio"
              label="WX_PAY"
            >微信支付(需付1%的手续费)</el-radio>
          </div>
        </div>
        <div class="typeButton">
          <el-button
            round
            size="mini"
            @click="immediatePayment"
          >&nbsp;&nbsp;&nbsp;立即支付&nbsp;&nbsp;&nbsp;</el-button>
          <el-button
            round
            type="danger"
            size="mini"
            @click="payMoneyDialog = false"
          >&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
        </div>
      </el-dialog>
      <template>
        <el-dialog
          title="二维码支付"
          :visible.sync="QRCodeDialog"
          align="center"
        >
          <vue-qr
            :text="config.value"
            :size="200"
          ></vue-qr>
          <el-row>二维码只会展示2分钟，请及时支付</el-row>
          <el-button @click="QRCodeDialog = false">关闭</el-button>
        </el-dialog>
      </template>
    </basic-container>
  </div>
</template>

<script>
import { serviceCouponDetailOption } from "@/const/salesCloud/serviceCouponDetailOption";
import {
  findCouponDetail,
  getBalance,
  immediatePay
} from "@/api/salesCloud/serviceCouponDetail";
import VueQr from "vue-qr";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";

export default {
  name: "serviceCouponDetail",
  components: {
    VueQr
  },
  data() {
    return {
      tableOption: serviceCouponDetailOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      loading: false,
      dialogFormVisible: false,
      form: { gender: "MALE" },
      formLabelWidth: "120px",
      classifySelects: [],
      currClassify: [],
      tabelObj: {},
      ids: "",
      radio: "BALANCE",
      payMoneyDialog: false,
      config: { value: "" },
      QRCodeDialog: false,
      balance: 0.0,
      isEnough: "true",
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      }
    };
  },
  created() {
    this.handleList();
    this.routeId = this.$route.params.id;
  },
  watch: {},
  mounted() {},
  computed: {},

  props: [],
  methods: {
    handlePay(row) {
      console.log(row);
      // row.redPacketTotal
      getBalance().then(res => {
        let data = JSON.parse(res.data);
        this.balance = data.rows[0].balance;
        if (this.balance < row.discountAmount) {
          this.isEnough = "false";
        } else {
          this.isEnough = "true";
        }
      });
      this.rowID = row.id;
      this.payMoneyDialog = true;
    },
    clean() {
      this.currClassify = "";
      this.classifySelects = [];
      this.form = {};
    },
    searchClear() {
      this.currClassify = "";
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      console.log(this.page);
      params.page = this.page.currentPage;
      params.size = pageSize;
      params.couponId = this.routeId;
      this.downloadData = params;
      findCouponDetail(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      params.couponId = this.routeId;
      this.downloadData = params;
      findCouponDetail(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      params.couponId = this.routeId;
      console.log(params);
      findCouponDetail(params).then(res => {
        if (res.code != 500) {
          let data = JSON.parse(res.data);
          this.tableData = data.rows;
          this.page = {
            total: data.total,
            currentPage: params.page,
            pageSize: params.size
          };
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.tableData = [];
          console.log(11);
        }
      });
    },
    //eslint-disable-next-line
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      params.couponId = this.routeId;
      this.downloadData = params;
      findCouponDetail(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // this.clean()
      this.clean();
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      // this.clean()
      // this.clientType = this.formatClientType(row.useCustomerType)
      // this.joinsWorkServiceCategory = {id: row.serviceCategoryId}
      // this.choseWorkServiceItem();
      // this.joinsWorkServiceItem = {id: row.serviceItemId}
      // if (row.startTime != null && row.endTime != null) {
      //     let array = []
      //     array.push(row.startTime)
      //     array.push(row.endTime)
      //     row.startTime_endTime = array
      // }
      console.log(row);
      this.clean();
      this.currClassify = row.rootId == 0 ? (row.rootId = "") : row.rootId;
      this.$refs.crud.rowEdit(row, index);
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        couponId: this.$route.params.id,
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      this.downloadData = params;
      findCouponDetail(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {},
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange(val) {
      let ids = val.map(item => {
        return item.id;
      });
      this.ids = ids.join(",");
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(row) {},
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log(row.id);
    },
    immediatePayment() {
      if (this.radio == "BALANCE") {
        let params = {
          id: this.rowID,
          payWay: this.radio
        };
        immediatePay(params).then(res => {
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "支付成功",
              type: "success"
            });
            this.payMoneyDialog = false;
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
          }
        });
      } else {
        let params = {
          id: this.rowID,
          payWay: this.radio
        };
        immediatePay(params).then(response => {
          this.tableLoading = false;
          if (response.code == "200") {
            let data = response.data;
            console.log(data);
            let count = 0;
            wxNativePayQuery(data.outTradeNo).then(res => {
              console.log(res);
              if (res.code == "200") {
                if (res.data == "SUCCESS") {
                  let _this = this;
                  setTimeout(function() {
                    _this.QRCodeDialog = false;
                    _this.$message({
                      showClose: true,
                      message: "支付成功",
                      type: "success"
                    });
                    _this.payMoneyDialog = false;
                    _this.handleList();
                    done();
                  }, 1000);
                } else {
                  count++;
                  if (count < 3) {
                    wxNativePayQuery(data.outTradeNo).then(res => {
                      if (res.code == "200") {
                        if (res.data == "SUCCESS") {
                          let _this = this;
                          setTimeout(function() {
                            _this.QRCodeDialog = false;
                            _this.$message({
                              showClose: true,
                              message: "支付成功",
                              type: "success"
                            });
                            _this.handleList();
                            _this.payMoneyDialog = false;
                            _this.rechargeDialog = false;
                            _this.payMoneyDialog = false;

                            done();
                            console.log("进来了");
                          }, 1000);
                        } else {
                          this.QRCodeDialog = false;
                          this.$message({
                            showClose: true,
                            message: "支付超时",
                            type: "error"
                          });
                          done();
                          console.log("超时", new Date());
                        }
                      } else {
                        this.QRCodeDialog = false;
                        this.$message({
                          showClose: true,
                          message: "支付超时",
                          type: "error"
                        });
                        done();
                        console.log("超时", new Date());
                      }
                    });
                  }
                }
                //this.handleList();
              } else {
                this.QRCodeDialog = false;
                this.$message({
                  showClose: true,
                  message: "支付超时",
                  type: "error"
                });
                done();
                this.handleList();
              }
            });
            let start = new Date().getTime();
            while (true) if (new Date().getTime() - start > 1) break;
            this.config.value = "";
            this.config.value = data.codeUrl;
            console.log("集合：" + this.config.value);
            this.QRCodeDialog = true;
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
            //???下面的感觉没用
            // done();
            // this.$refs.crud.rowAdd();
            return;
          }
          // let data = JSON.parse(res.data);
        });
      }
    }
  }
};
</script>

<style lang="scss">
.typeButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 150px;
}
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
